import React, { useEffect, useState } from 'react';
import { Inspiration, User } from '../../../global';
import styles from './InspirationCard.module.scss';
import { useAuth } from '../../../context/AuthContext';
import SquaredImage from '../../SquaredImage/SquaredImage';
import inspirationPlaceholder from '../../../assets/Inspiration.png';
import ActionButton from '../../ActionButton/ActionButton';
import PopUpInspirationImage from '../../PopUp/PopUpInspirationImage/PopUpInspirationImage';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { useNavigate } from 'react-router-dom';

interface NewInspirationCardProps {
  inspiration: Inspiration;
  loggedUser: User | null;
  shownInUserProfile: boolean;
  editCallback: (inspiration: Inspiration) => void;
  changeCallback: (inspiration: Inspiration) => void;
}

const NewInspirationCard: React.FC<NewInspirationCardProps> = ({ inspiration, loggedUser, shownInUserProfile, editCallback, changeCallback }) => {
  const redirect = useNavigate();
  const { showLoginPopup, voteInspiration, isInspirationLiked } = useAuth();
  const [image, setImage] = useState<string>(inspirationPlaceholder);
  const [popUp, setPopUp] = useState<boolean>(false);
  const [showEditButton, setShowEditButton] = useState<boolean>(false);

  const goToUserDetail = (user: User) => {
    redirect(`/${ROUTEPATHS.USER}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PROFILE}`);
  };

  const goToContest = (contest: any) => {
    redirect(`/${ROUTEPATHS.CONTEST}/${contest.nameForURL}/${ROUTEPATHS.CONTEST_BRIEF}`);
  };

  const editInspiration = () => {
    console.log('Edit inspiration:', inspiration);
    editCallback(inspiration);
    // Implement edit inspiration functionality
  };

  function youtube_parser(url?: string) {
    if (url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? `https://img.youtube.com/vi/${match[7]}/hqdefault.jpg` : inspirationPlaceholder;
      // } else {
      // return '';
    }
  }

  useEffect(() => {
    if (inspiration) {
      setShowEditButton(false);
      if (loggedUser && inspiration.user.id === loggedUser.id) {
        setShowEditButton(true);
      }
      const img = inspiration.imageAttachment?.s3Path || youtube_parser(inspiration.websiteURL);
      if (img) {
        setImage(img);
      } else {
        setImage(inspirationPlaceholder);
      }
    }
  }, [inspiration]);

  const goOut = () => {
    // if (!actionClick) {
    if (inspiration.websiteURL) {
      // redirect(props.url);z
    } else {
      if (loggedUser) {
        setPopUp(true);
      } else {
        showLoginPopup();
      }
    }
    // }
  };
const voteAndUpdate = async () => {
    const updatedInspiration = await voteInspiration(inspiration);
    if (updatedInspiration) {
      changeCallback(updatedInspiration);
    }
  }
  return (
    <div className="col-12 col-md-6  d-flex flex-row  ps-4   col-lg-4 col-xl-3 mb-4">
      <div className={`${styles.card} col-12  col-md-6 col-lg-3 position-relative `}>
        <div className={`${styles.cardInfoWrapper}  d-flex flex-column  bg-light`}>
          <div className={`${styles.cardInfoImage} bg-light position-relative cursor-pointer`} onClick={() => goOut()}>
            {inspiration.websiteURL ? (
              <a href={inspiration.websiteURL} target="_blank" rel="noopener noreferrer">
                <SquaredImage image={image} altText={'props.altText'} circle={false} />
              </a>
            ) : (
              <SquaredImage image={image} altText={'props.altText'} circle={false} />
            )}
            {showEditButton ? (
              <ActionButton icon="edit" label={`Edit inspiration`} color={!loggedUser ? 'light-gray-3' : ''} position="top-right" action={() => editInspiration()} />
            ) : (
              <>
                {!isInspirationLiked(inspiration) ? (
                  <ActionButton
                    icon="heart"
                    label={`${inspiration.votesCount} votes`}
                    color={!loggedUser ? 'light-gray-3' : ''}
                    position="top-right"
                    action={voteAndUpdate}
                  />
                ) : (
                  <ActionButton label={`${inspiration.votesCount} votes`} icon="solidheart" position="top-right" action={() => {}} />
                )}
              </>
            )}

            {inspiration.isPrivate && <ActionButton label={`Private inspiration`} icon="private" position="bottom-left" />}
          </div>

          <div className={`${styles.cardInfoContent} container bg-light`}>
            <div className="row h-25 mt-2 mb-3 mx-1">
              {!shownInUserProfile ? (
                <div className="col text-center align-self-center" onClick={() => goToUserDetail(inspiration.user)}>
                  <h3 className="fw-bold color-blue d-sm-none d-md-block" style={{ cursor: 'pointer' }}>
                    {inspiration.user.username}
                  </h3>
                  <h1 className="fw-bold color-blue d-md-none d-sm-block">{inspiration.user.username}</h1>
                </div>
              ) : (
                <div className="col text-center  align-self-center" onClick={() => goToContest(inspiration.contest)}>
                  <h3 className="fw-bold color-blue d-sm-none d-md-block " style={{ cursor: 'pointer' }}>
                    {inspiration.contest?.name || ''}
                  </h3>
                  <h1 className="fw-bold color-blue d-md-none d-sm-block">{inspiration.contest?.name || ''}</h1>
                </div>
              )}
            </div>

            <div className=" col align-self-center text-justify py-3 px-4">{inspiration.textDescription}</div>
          </div>
        </div>
        {image && <PopUpInspirationImage image={image} popup={popUp} close={() => setPopUp(false)} />}
      </div>
    </div>
  );
};

export default NewInspirationCard;
